<template>
    <div>
        <el-table :data="appComponentList">
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="显示隐藏" prop="display">
                <template slot-scope="scope">
                    <el-switch active-color="#13ce66" @change="handleDisplay(scope.row.id, $event)" :value="scope.row.display"/>
                </template>
            </el-table-column>
            <el-table-column label="底部Margin" prop="bottomMargin"></el-table-column>
            <el-table-column label="顶部Margin" prop="topMargin"></el-table-column>
            <el-table-column label="当前排序" prop="sortNum"></el-table-column>
            <el-table-column label="排序">
                <template slot-scope="scope">
                    <el-input v-model="scope.row.newSort" style="width:100px">
                        <template slot="append">
                            <el-button type="text" @click="setSortNum(scope.row.id,scope.row.newSort)">设置</el-button>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import api from './api';
    import "../store";
    import {mapActions, mapState} from "vuex";
    export default {
        name: "appComponent",
        computed:{
          ...mapState('PortalManage',['appComponentList'])
        },
        methods:{
            ...mapActions("PortalManage", ["selectAppComponent"]),
            setSortNum(id,num){
                api.componentSortNum({id:id,sortNum:num}).then(()=>{
                    this.$message.success('排序成功');
                    this.selectAppComponent();
                })
            },
            handleDisplay(id,display){
                api.componentDisplay({id : id,display:display}).then(()=>{
                    this.$message.success('操作成功');
                    this.selectAppComponent();
                })
            }
        }
    }
</script>

<style scoped>

</style>
